import { Layout } from 'antd';

import './Footer.css';

const Footer = ({ bgColor }) => {
  return (
    <Layout.Footer className="footer" style={{ backgroundColor: bgColor }}>
      Copyright World Family English, Ltd. &copy; 2021. All Rights Reserved.
    </Layout.Footer>
  );
};

export default Footer;
